<template>
  <TheLayout>
    <div
      class="custom_theo_design"
      v-if="dataPermission && dataPermission.includes('NSH_PARTNER_CUS_VIEW')"
    >
      <div class="row">
        <div class="col-12">
        <div
          class="
          page-title-box
          d-flex
          align-items-center
          justify-content-between
          "
        >
          <b class="fs-16 text-bold">KHÁCH HÀNG</b>
        </div>
        </div>
      </div>
      <div class="tab_group_custom mb-3 d-flex align-items-center">
        <a
          href="javascript:void(0)"
          class="linkItemTab active"
          @click="$router.push(`/customer-list`)"
          >Danh sách khách hàng</a
        >
        <span class="border"></span>
        <a
          href="javascript:void(0)"
          class="linkItemTab"
          @click="$router.push(`/group-customer`)"
          >Nhóm khách hàng</a
        >
      </div>
      <div>
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-body">
                <div class="d-flex justify-content=between mb-3">
                  <b-input-group class="wrapperInput">
                    <el-popover
                      placement="bottom-start"
                      width="90vw"
                      trigger="click"
                      v-model="filterModal"
                    >
                      <div class="boxPopovers">
                        <div class="d-flex justify-content-between">
                          <el-select
                            v-model="groupsId"
                            placeholder="Nhóm khách hàng"
                            class="el"
                          >
                            <el-option
                              v-for="item in listGroup"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                          <el-select
                            v-model="typeId"
                            clearable
                            placeholder="Phân loại"
                            class="ml-1 el"
                          >
                            <el-option
                              v-for="item in listType"
                              :key="item.id"
                              :label="item.text"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                        </div>
                        <div class="mt-2">
                          <el-select
                            v-model="genderId"
                            clearable
                            placeholder="Giới tính"
                            class="w-100 el"
                          >
                            <el-option
                              v-for="item in listGender"
                              :key="item.id"
                              :label="item.text"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                        </div>
                        <div class="d-flex my-2 align-items-center">
                          <div class="w-25 text-right mr-2">Sinh nhật: </div>
                          <el-date-picker
                            class="el col-8 pull-right"
                            type="daterange"
                            align="right"
                            start-placeholder="Từ ngày"
                            end-placeholder="Đến ngày"
                            format="dd/MM/yyyy"
                            v-model="dateRange"
                            :clearable="false"
                          >
                          </el-date-picker>
                        </div>
                        <div class="mt-2 clearfix text-right">
                          <BaseButton
                            variant="outline"
                            class="ml-3 b-primary pull-right"
                            @click="fetchData"
                            >Áp dụng bộ lọc</BaseButton
                          >
                          <BaseButton
                            variant="outline"
                            class="ml-3 b-remove pull-right"
                            @click="removeFilter"
                            >Xóa bộ lọc</BaseButton
                          >
                          <BaseButton
                            variant="primary"
                            class="ml-3 b-destroy pull-right"
                            @click="filterModal = false"
                            >Huỷ</BaseButton
                          >
                        </div>
                      </div>
                      <el-button style="padding:7px 16px 7px 12px; height: 44px" slot="reference" type="info" plain>
                        <div class="justify-content-center align-items-center d-flex">
                          <div><i style="font-size:24px; margin-right:4px" class="mdi mdi-filter-outline"></i></div> Bộ lọc
                        </div>
                      </el-button>
                    </el-popover>
                    <el-input
                      v-model="filter"
                      @change="fetchData"
                      @enter="fetchData"
                      placeholder="Tìm kiếm theo tên, SĐT"
                      prefix-icon="el-icon-search"
                      style="width: 280px"
                      clearable
                      class="ml-2"
                    >
                    </el-input>
                  </b-input-group>
                    <el-button @click="exportData" style="padding:7px 16px 7px 12px; height: 44px" slot="reference" type="info" plain>
                      <div class="justify-content-center align-items-center d-flex">
                        <div><i style="font-size:24px; margin-right:4px" class="mdi mdi-import"></i></div> Xuất dữ liệu
                      </div>
                    </el-button>
                    <el-button  @click="modalImport = true" style="padding:7px 16px 7px 12px; height: 44px" slot="reference" type="info" plain>
                      <div class="justify-content-center align-items-center d-flex">
                        <div><i style="font-size:24px; margin-right:4px" class="mdi mdi-import"></i></div> Nhập dữ liệu
                      </div>
                    </el-button>
                    <el-button v-if="dataPermission &&dataPermission.includes('NSH_PARTNER_CUS_CREATE')"  @click="clickAdd()" style="padding:7px 16px 7px 12px; height: 44px" slot="reference" type="primary">
                      <div class="justify-content-center align-items-center d-flex">
                        <div><i style="font-size:18px; margin-right:4px" class="fa-solid fa-plus"></i></div> Thêm mới KH
                      </div>
                    </el-button>
                </div>
                <div class="row mb-2" v-if="selected.length > 0">
                  <div class="col-md-12">
                    <span class="mt-2 d-inline mr-2"
                      >Đã chọn {{ selected.length }} khách hàng</span
                    >
                    <el-button
                      type="danger"
                      plain
                      @click="deleteItem(selected)"
                      v-if="
                        dataPermission &&
                        dataPermission.includes('NSH_PARTNER_CUS_DELETE')
                      "
                      >Xóa khách hàng
                    </el-button>
                  </div>
                </div>
                <div class="table-responsive mb-0 mt-2">
                  <b-table
                    head-variant="light"
                    hover
                    :items="dataCustomer"
                    :fields="fields"
                    tbody-tr-class="row-table-class"
                  >
                    <template #table-caption v-if="totalElements == 0">
                      <div class="emptyData">
                        <i>Danh sách khách hàng trống</i>
                      </div>
                    </template>

                    <template v-slot:head(selected)>
                      <b-form-checkbox v-model="selectAll" />
                    </template>

                    <template #cell(selected)="data">
                      <b-form-group style="margin-bottom: 0px">
                        <b-form-checkbox
                          v-model="selected"
                          :value="data.item"
                        />
                      </b-form-group>
                    </template>

                    <template #cell(data-img)="data">
                      <span class="data-img">
                        <img
                          class="rounded-circle"
                          v-if="data.item.avatarUrl"
                          :src="data.item.avatarUrl"
                          style="width: 36px"
                        />
                        <img
                          class="rounded-circle"
                          v-else
                          src="@/assets/images/765-default-avatar.png"
                          style="width: 36px"
                        />
                      </span>
                    </template>
                    <template #cell(name)="data">
                      <p
                        style="margin: 0px; white-space: nowrap"
                        class="text-primary d-inline"
                        v-if="
                          dataPermission &&
                          dataPermission.includes('NSH_PARTNER_CUS_VIEW')
                        "
                        @click="clickView(data.item)"
                      >
                        {{ data.item.name }}
                      </p>
                    </template>

                    <template #cell(group)="data">
                      <div
                        v-if="
                          dataPermission &&
                          dataPermission.includes('NSH_PARTNER_CUS_VIEW')
                        "
                      >
                        <p
                          style="margin: 0px; white-space: nowrap"
                          v-for="(item, index) in data.item.groups"
                          :key="index"
                          @click="clickView(data.item)"
                        >
                          {{ item.name }}
                        </p>
                      </div>
                    </template>

                    <template #cell(isPerson)="data">
                      <p
                        v-if="
                          dataPermission &&
                          dataPermission.includes('NSH_PARTNER_CUS_VIEW')
                        "
                        style="margin: 0px; white-space: nowrap"
                        @click="clickView(data.item)"
                      >
                        {{ data.item.isPerson ? "Cá nhân" : "Doanh nghiệp" }}
                      </p>
                    </template>

                    <template #cell(phoneNo)="data">
                      <p
                        style="margin: 0px; white-space: nowrap"
                        v-if="
                          dataPermission &&
                          dataPermission.includes('NSH_PARTNER_CUS_VIEW')
                        "
                        @click="clickView(data.item)"
                      >
                        {{ data.item.phoneNo }}
                      </p>
                    </template>
                  </b-table>
                </div>
              </div>
              <div class="row d-flex justify-content-end mr-3">
                <div
                  class="
                    order-list-nav order-list-footer
                    d-flex
                    justify-content-end
                  "
                >
                  <b-pagination
                    @change="changeCurrentPage"
                    v-model="currentPage"
                    :total-rows="totalElements"
                    :per-page="search.pageSize"
                    aria-controls="debt-table"
                    hide-goto-end-buttons
                    limit="5"
                    last-text="next"
                    align="right"
                  />
                </div>
              </div>
            </div>

            <div class="box-loading" v-if="loading">
              <div class="loading">
                <b-spinner
                  class="m-2"
                  variant="primary"
                  role="status"
                ></b-spinner>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Modal import-->
      <b-modal id="modal-scoped" v-model="modalImport" no-close-on-backdrop>
        <template #modal-header="{}">
          <h5 class="mb-0">
            <p style="font-weight: bold">Nhập danh sách khách hàng</p>
          </h5>
          <button
            type="button"
            size="sm"
            aria-label="Close"
            class="close"
            @click="importCancels()"
          >
            ×
          </button>
        </template>
        <template #default>
          <ul class="dotUL ml-4">
            <li>
              Tải file mẫu
              <a target="_blank" href="/assets/files/ReportCustomers.xlsx"
                >tại đây</a
              >
              (Cập nhật ngày 22/12/2021)
            </li>
            <li>File có định dạng .XLSX và giới hạn 3000 dòng</li>
          </ul>
          <label class="step-content" tabindex="0" for="file">
            <div class="input-file-containers">
              <input
                class="input-file"
                style="display: none"
                id="file"
                @change="uploadFileExcel"
                ref="file"
                type="file"
                accept=".xlsx,.xls,.csv"
              />
              <p v-if="messFailFormat" class="color-red">
                <i class="bx bxs-cloud-upload mr-2"></i> {{ messFailFormat }}
              </p>
              <p v-if="keyCheckUpload == 0 && messFailFormat == ''">
                <i class="bx bxs-cloud-upload mr-2"></i> Bấm vào đây để tải lên
                từ thiết bị
              </p>
              <p v-if="keyCheckUpload == 1" class="text-bold text-dark">
                <i class="bx bxs-cloud-upload mr-2"></i> File: {{ fileName }}
              </p>
            </div>
          </label>
        </template>

        <template #modal-footer="{}">
          <div class="d-flex justify-content-between w-100 m-0">
            <b-button variant="danger" size="md" class="m-0" @click="cancel()"
              >Hủy
            </b-button>
            <b-button variant="primary" size="md" class="m-0" v-if="isUpload"
              ><i class="fas fa-spinner fa-spin"></i> Đang tải</b-button
            >
            <b-button
              variant="primary"
              size="md"
              class="m-0"
              v-if="!isUpload"
              @click="importData"
              >Hoàn tất</b-button
            >
          </div>
        </template>
      </b-modal>

      <!--Xóa Item-->
      <el-dialog
        title="Xoá khách hàng"
        v-if="modalRemove"
        :visible.sync="modalRemove"
        id="modalRemove"
        width="500px"
        @close="modalRemove = false"
      >
        <div class="line text-center">
          <div class="mt-2">
            <img src="@/assets/images/customer-nope-1.svg" />
          </div>
          <div class="mt-2">
            Bạn chắc chắn muốn xoá các khách hàng đã chọn ?<br />
            Thao tác này không thể khôi phục.
          </div>
        </div>
        <div class="line mt-4 bdt-btn-action">
          <div class="padd5">
            <button
              @click="confirmRemove"
              type="button"
              class="btn btn-default btn-default-red pull-right"
            >
              Xác nhận xoá
            </button>
            <button
              type="button"
              class="btn btn-default-ext text-primary pull-right"
              @click="modalRemove = false"
            >
              Thoát
            </button>
          </div>
        </div>
      </el-dialog>
    </div>
    <NotPermission v-else></NotPermission>
  </TheLayout>
</template>
<script>
import Swal from "sweetalert2";
import { CustomerServices } from "@/services/nextshop/customer.service";
import moment from "moment";

export default {
  data() {
    return {
      dataPermission: JSON.parse(localStorage.getItem("dataPermission")),
      inforAccount: JSON.parse(localStorage.getItem("auth.currentUser")),
      loading: false,
      fields: [
        {
          key: "selected",
          label: "",
          thStyle: { width: "1%" },
        },
        {
          key: "name",
          label: "Tên khách hàng",
          thStyle: { width: "15%" },
        },
        {
          key: "phoneNo",
          label: "Số điện thoại",
          thStyle: { width: "10%" },
        },
        {
          key: "group",
          label: "Nhóm",
          thStyle: { width: "10%" },
        },
        {
          key: "isPerson",
          label: "Phân loại",
          thStyle: { width: "8%" },
        },
      ],
      dataCustomer: [],
      selected: [],
      search: {
        pageNum: 1,
        pageSize: 30,
      },
      currentPage: 1,
      filter: "",

      modalImport: false,
      formData: null,
      messFailFormat: "",
      keyCheckUpload: 0,
      fileName: "",
      isUpload: false,
      totalElements: 0,
      modalRemove: false,
      dataRemove: {},
      filterModal: false,
      listGroup: [],
      groupsId: "",
      listType: [
        { id: true, text: "Cá nhân" },
        { id: false, text: "Doanh nghiệp" },
      ],
      typeId: "",
      listGender: [
        { id: "FEMALE", text: "Nữ" },
        { id: "MALE", text: "Nam" },
        { id: "OTHERS", text: "Khác" },
      ],
      genderId: "",
      dateRange: [],
    };
  },
  async created() {
    await this.fetchData();
    await this.getGroup();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        let searchFilters = {
          typePartner: "CUSTOMER",
          pageNum: this.search.pageNum,
          pageSize: this.search.pageSize,
        };
        if (this.filter != "") {
          searchFilters.textSearch = this.filter;
        }
        if (typeof this.typeId == "boolean") {
          searchFilters.isPerson = this.typeId;
        }
        if (this.groupsId != "") {
          searchFilters.groupList = [this.groupsId];
        }
        if (this.genderId != "") {
          searchFilters.sex = this.genderId;
        }
        if (this.dateRange.length > 0) {
          const _start = moment(this.dateRange[0]).format("MM-DD");
          const _end = moment(this.dateRange[1]).format("MM-DD");
          searchFilters.birthDay = {
            startDate: _start,
            endDate: _end,
          };
        }

        searchFilters.sort = "id";
        searchFilters.sortType = "DESC";

        const response = await CustomerServices.getListCustomerPagging(
          searchFilters
        );
        if (response.success) {
          this.dataCustomer = response.data.data;
          this.totalElements = response.data.totalElements;
        }
      } catch (error) {
        console.error(error);
      }
      this.filterModal = false;
      this.loading = false;
    },
    deleteItem(data) {
      this.modalRemove = true;
      this.dataRemove = data;
    },
    async confirmRemove() {
      this.modalRemove = false;
      this.loading = true;

      try {
        if (this.dataRemove.length > 0) {
          const params = this.dataRemove.map((e) => {
            return e.id;
          });
          const response = await CustomerServices.deleteCustomer({
            merchantId: this.inforAccount.merchantId,
            partnerIds: params,
          });
          if (response.success) {
            this.fetchData();
            this.selected = [];
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    clickAdd() {
      this.$router.push({ path: `/customer-list/customer-add` });
    },
    clickView(data) {
      this.$router.push({ path: `/customer-list/customer-detail/${data.id}` });
    },
    remove() {
      this.filter = "";
      this.fetchData();
    },
    async exportData() {
      try {
        const params = {
          merchantId: this.inforAccount.merchantId,
          person: 1,
        };
        this.loading = true;
        const response = await CustomerServices.exportData(params);
        if (response.status == 200) {
          Swal.fire({
            title: "Xuất dữ liệu thành công",
            text: `Dữ liệu danh sách khách hàng sẽ được tải về thiết bị của bạn`,
            icon: "success",
            confirmButtonText: "Xác nhận",
          }).then((result) => {
            if (result.value) {
              this.fetchData();
            }
          });
        }
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
    async uploadFileExcel() {
      const allowedExtensions = /(\.xls|\.xlsx|\.csv)$/i;
      const checkFomat = allowedExtensions.exec(this.$refs.file.value);

      this.fileName = this.$refs.file.files[0].name;
      this.messFailFormat = "";
      this.formData = new FormData();
      this.formData.append("file", this.$refs.file.files[0]);
      this.formData.append("merchantId", this.inforAccount.merchantId);

      if (!checkFomat) {
        this.keyCheckUpload = 2;
        this.messFailFormat = "Định dạng không hợp lệ !";
        this.fileName = "";
      } else {
        this.keyCheckUpload = 1;
      }
    },
    async importData() {
      try {
        if (this.formData === null) {
          this.messFailFormat = "Vui lòng chọn file tải lên !";
          return false;
        }
        this.isUpload = true;
        const response = await CustomerServices.importData(this.formData);

        let _title = "";
        let _icon = "";
        if (response.success == false) {
          _title = "Nhập dữ liệu lỗi";
          _icon = "error";
        } else {
          _title = "Nhập dữ liệu thành công";
          _icon = "success";
        }

        if (response.status == 200) {
          this.isUpload = false;
          Swal.fire({
            title: _title,
            text: response.data.data.message,
            icon: _icon,
            confirmButtonText: "Xác nhận",
            closeOnClickOutside: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then((result) => {
            if (result.value) {
              this.fetchData();
              this.importCancels();
            }
          });
        }
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
    importCancels() {
      this.fileName = "";
      this.keyCheckUpload = 0;
      this.messFailFormat = "";
      this.formData = null;
      this.modalImport = false;
    },
    async getGroup() {
      try {
        const response = await CustomerServices.getGroupCustomer({
          merchantId: this.inforAccount.merchantId,
          query: "",
          sort: "date",
          page: 1,
          limit: 100,
        });
        if (response.success) {
          this.listGroup = response.data.data;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async removeFilter() {
      this.groupsId = "";
      (this.typeId = ""), (this.genderId = ""), (this.dateRange = {});
      this.fetchData();
    },
    changeCurrentPage(page) {
      this.currentPage = page;
      this.search.pageNum = page;
      this.fetchData();
    },
  },
  computed: {
    selectAll: {
      get: function () {
        return this.dataCustomer.length
          ? this.selected.length == this.dataCustomer.length
          : false;
      },
      set: function (value) {
        let selected = [];
        if (value) {
          this.dataCustomer.forEach(function (val) {
            selected.push(val);
          });
          this.selected = selected;
        } else {
          if (this.selected.length == this.dataCustomer.length) {
            this.selected = [];
          }
        }
        this.selected = selected;
      },
    },
  },
};
</script>
<style lang="scss">

.el-input__inner {
  height: 44px !important;
}
</style>

<style lang="scss" scoped>
.dotUL {
  li {
    margin-bottom: 8px;
    list-style-type: disc;
  }
}
.step-content {
  text-align: center;
  border: 2px dashed #ced4da;
  padding: 80px 0;
  margin: 20px 0 0;
  width: 100%;
  cursor: pointer;
}
.input-file-containers {
  font-size: 14px;
  color: #ced4da;
  cursor: pointer;
}
.input-file-containers .bxs-cloud-upload {
  font-size: 20px;
  position: relative;
  top: 3px;
  cursor: pointer;
}
.btn-outline-info {
  color: #3e69f6;
  border: 1px solid #3e69f6;
}
.btn-outline-info:hover {
  color: #3e69f6;
  background: #fff !important;
}
.linkItemTab {
  font-weight: bold;
  color: #808890;
  font-size: 18px;
}
.linkItemTab.active {
  font-weight: bold;
  color: #23313e;
}
.seperate {
  color: #808890;
  padding: 0 10px;
}
.btn-default {
  background: #f2f3f4 !important;
}
.btn-danger-ext {
  background: #fef3f5 !important;
  border-color: #fef3f5 !important;
  color: #dc2323 !important;
}
.padding-ext {
  padding: 10px !important;
}
.btn.btn-filter {
  background: #eff2f7 !important;
  border: 1px solid #eff2f7;
  color: #23313e !important;
  width: 100%;
  display: inline-block;
  padding: 5px 10px !important;
}
.__checkbox {
  display: inline-block;
}
.table td {
  padding: 15px 0.75rem 15px !important;
}
::v-deep #modalRemove .el-dialog__body {
  padding: 20px 0px 15px;
  display: inline-block;
  width: 100%;
}
.btn-default-ext {
  background: none !important;
  color: #3e69f6 !important;
}
.b-primary {
  background: #3e69f6 !important;
  color: #fff !important;
}
.b-remove {
  background: #fff !important;
  color: #dc2323 !important;
  border: 1px solid #f8b6c2 !important;
}
.b-destroy {
  color: #23313e !important;
  background: #fff !important;
  border: 1px solid #dddddd !important;
}
.input-group-text {
  background: none !important;
}
.wrapperInput .form-control {
  border-left: none !important;
  padding-left: 0 !important;
}
.icon13 {
  height: 13px;
  position: relative;
  top: -1px;
}
.bd-0 {
  border: none !important;
}
.btn-default-red {
  background: #fef3f5 !important;
  border-color: #fef3f5 !important;
  color: #dc2323 !important;
}
::v-deep .fa-search {
  color: #7c7e93 !important;
}
::v-deep .modal-content .form-group {
  padding: 0 15px;
}
</style>
